import { marked } from 'marked';
import React, { useMemo } from 'react';

interface MarkdownViewerProps {
  content?: string;
  className?: string;
}

// Configure marked for safe HTML output
marked.setOptions({
  breaks: true, // Convert \n to <br>
  gfm: true, // GitHub Flavored Markdown
});

const MarkdownViewer: React.FC<MarkdownViewerProps> = ({
  content,
  className,
}) => {
  const htmlContent = useMemo(() => {
    if (!content) return '';
    return marked.parse(content) as string;
  }, [content]);

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
};

export default React.memo(MarkdownViewer);
